export default "__VITE_ASSET__DV7dPL0g__"